export default "__VITE_ASSET__B2AzV$bq__"